module.exports = __webpack_public_path__ + "static/media/logo.a7a32b51.svg";